export default __webpack_public_path__ + "static/media/black-decker.97bd77bd.png";